var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 35.3325,
    rx: 17.6663,
    fill: "#EDEFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33422 26.9992L6.09427 26.5059C6.00567 26.7288 5.97886 26.9715 6.01665 27.2084C6.05445 27.4453 6.15546 27.6676 6.30903 27.8519C6.4626 28.0362 6.66304 28.1756 6.88923 28.2555C7.11541 28.3354 7.35897 28.3528 7.59421 28.3058L7.33422 26.9992ZM13.6086 25.7513L14.2406 24.5766L13.818 24.35L13.3487 24.4433L13.6086 25.7513ZM9.49947 21.5554L10.7394 22.0487L10.9567 21.4968L10.6954 20.9648L9.49947 21.5554ZM27.3334 17.6662C27.3334 21.9941 23.5296 25.6659 18.6271 25.6659V28.3325C24.8149 28.3325 30 23.6473 30 17.6662H27.3334ZM9.92212 17.6662C9.92212 13.3384 13.7273 9.66656 18.6284 9.66656V7C12.4407 7 7.25422 11.6852 7.25422 17.6662H9.92212ZM18.6284 9.66656C23.5296 9.66656 27.3334 13.3384 27.3334 17.6662H30C30 11.6852 24.8162 7 18.6284 7V9.66656ZM18.6271 25.6659C17.0205 25.6659 15.5246 25.266 14.2406 24.5766L12.9767 26.9246C14.7151 27.8543 16.6557 28.3381 18.6271 28.3325V25.6659ZM7.59421 28.3058L13.8686 27.0579L13.3487 24.4433L7.07423 25.6913L7.59421 28.3072V28.3058ZM10.6954 20.9648C10.1862 19.9398 9.92242 18.8108 9.92212 17.6662H7.25422C7.25422 19.2662 7.63021 20.7835 8.30218 22.1461L10.6954 20.9648ZM8.26085 21.0621L6.09427 26.5072L8.57151 27.4912L10.7368 22.0474L8.25952 21.0621H8.26085Z",
    fill: "#5D34F3",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0012 18.9991C14.7376 18.9991 15.3345 18.4022 15.3345 17.6658C15.3345 16.9294 14.7376 16.3325 14.0012 16.3325C13.2649 16.3325 12.668 16.9294 12.668 17.6658C12.668 18.4022 13.2649 18.9991 14.0012 18.9991Z",
    fill: "#5D34F3",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6653 18.9991C19.4017 18.9991 19.9986 18.4022 19.9986 17.6658C19.9986 16.9294 19.4017 16.3325 18.6653 16.3325C17.929 16.3325 17.332 16.9294 17.332 17.6658C17.332 18.4022 17.929 18.9991 18.6653 18.9991Z",
    fill: "#5D34F3",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 18.9996C24.0696 18.9996 24.6666 18.4026 24.6666 17.6663C24.6666 16.9299 24.0696 16.333 23.3333 16.333C22.5969 16.333 22 16.9299 22 17.6663C22 18.4026 22.5969 18.9996 23.3333 18.9996Z",
    fill: "#5D34F3",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.18c57d7ed024075c84107c3943fbd3da.svg";
export { ForwardRef as ReactComponent };